// これが重要！ `compat` を使う
import firebase from 'firebase/compat/app'
import 'firebase/compat/auth'
import 'firebase/compat/firestore'
import 'firebase/compat/storage'

const firebaseConfig = require('./firebase.client.key.json')
// 2回目の初期化を防ぐ
if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig)
}

// v8スタイルで export
export const auth = firebase.auth()
export const db = firebase.firestore()
export const storage = firebase.storage()
export default firebase
